module.exports = __webpack_public_path__ + "b1f74ca6beddc0df29297fd58fe37ea9.jpg";